/**
 * Language selector component.
 * @module components/LanguageSelector/LanguageSelector
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import cx from 'classnames';
import find from 'lodash/find';
import map from 'lodash/map';

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import langmap from '@plone/volto/helpers/LanguageMap/LanguageMap';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { toReactIntlLang } from '@plone/volto/helpers/Utils/Utils';

import config from '@plone/volto/registry';

import { defineMessages, useIntl } from 'react-intl';

import { Dropdown } from 'semantic-ui-react'

const messages = defineMessages({
  switchLanguageTo: {
    id: 'Switch to',
    defaultMessage: 'Switch to',
  },
  selectLanguageButton: {
    id: 'Select your language',
    defaultMessage: 'Select your language'
  }
});

const LanguageSelector = (props) => {
  const intl = useIntl();
  var currentLang = '';
  switch (useSelector((state) => state.intl.locale)) {
    case 'ca':
      currentLang = 'cat';
      break;
    case 'es':
      currentLang = 'esp';    
      break;
    case 'en':
      currentLang = 'eng';
      break;
    default:
      currentLang = '';
  }
  const translations = useSelector(
    (state) => state.content.data?.['@components']?.translations?.items,
  );

  const { settings } = config;

  return settings.isMultilingual ? (
    <Dropdown 
      text={currentLang} 
      aria-label={intl.formatMessage(messages.selectLanguageButton)} 
      className="language-selector me-0"
      direction="left">
      <Dropdown.Menu>        
        {map(settings.supportedLanguages, (lang) => {
          const translation = find(translations, { language: lang });
          return (
            <Dropdown.Item key={`language-selector-${lang}`}>
              <Link
                aria-label={`${intl.formatMessage(
                  messages.switchLanguageTo,
                )} ${langmap[lang].nativeName.toLowerCase()}`}
                className={cx({ selected: toReactIntlLang(lang) === currentLang })}
                to={translation ? flattenToAppURL(translation['@id']) : `/${lang}`}
                title={langmap[lang].nativeName}
                onClick={() => {
                  props.onClickAction();
                }}
                
              >
                {langmap[lang].nativeName}
              </Link>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <Helmet>
      <html lang={toReactIntlLang(settings.defaultLanguage)} />
    </Helmet>
  );
};

LanguageSelector.propTypes = {
  onClickAction: PropTypes.func,
};

LanguageSelector.defaultProps = {
  onClickAction: () => {},
};

export default LanguageSelector;
